import { Typography } from "@mui/material";
import HelpDialogLayout, { BodyTypographies, ContentStack, HelpDialogLayoutProps, SectionStack } from "./HelpDialogLayout";

export interface SnoringDialogProps extends HelpDialogLayoutProps {}
export default function SnoringDialog(props: SnoringDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            いびきの原因と改善策
          </Typography>
          <BodyTypographies
            contents={[
              "いびきは、睡眠中に気道が狭くなることで発生する一般的な現象です。特に仰向けで寝ると、喉の奥の筋肉や舌の根元が重力で下がり、気道が狭くなるため、いびきをかきやすくなります。",
              "たまにいびきをかくことは健康な人にも起こりますが、大きないびきや睡眠中の無呼吸がある場合は、睡眠時無呼吸症候群の可能性があるため、気になる場合は検査を受けましょう。",
            ]}
          />
        </SectionStack>

        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            いびきの改善策
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "いびきは、以下のような生活習慣の見直しによって軽減できることがあります。",
              ]}
            />
            <BodyTypographies
              contents={[
                "鼻づまりの解消（耳鼻科での治療）",
                "鼻が詰まると口呼吸になり、いびきをかきやすくなるため、鼻呼吸ができる環境を整えましょう。",
                "具体的には耳鼻科での治療や、鼻呼吸を促すために口を閉じるテープなども市販されています。",
              ]}
            />
            <BodyTypographies
              contents={[
                "節酒・禁煙",
                "お酒は筋肉を緩め、たばこは炎症を引き起こし気道を狭くするため、控えることでいびきを軽減できます。",
              ]}
            />
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
